import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import ValidationWarningModal from '@shared/components/modals/validation-warning-modal/validation-warning-modal.vue';
import BPCGenericApiResponse from '@core/interfaces/bpc-generic-api-response';
import EntityFormProvider from '@shared/components/forms/auto-form/entity-form-provider/entity-form-provider';
import StdForm from '@shared/components/forms/auto-form/std-form/std-form';

@Component({
  components: {
    'bpc-validation-warning-modal': ValidationWarningModal,
  },
})
export default class ValidationWarning extends Vue {
  @Prop({ type: Boolean, default: false }) readonly emitOnValidationWarning: boolean;

  $refs: {
    stdForm: InstanceType<typeof StdForm> & {
      saveEntity(): Promise<BPCGenericApiResponse>;
      formModel: any;
      onDeleteMediaFile(): void;
      searchEntity(): void;
      extraData: string | AnyEntity;
      formProvider: EntityFormProvider;
    };
  };

  isExportingTable = false;
  showValidationWarningModal: boolean = false;
  waitingValidationWarningConfirm: boolean = false;
  warningMessages = [];

  onValidationWarning(error) {
    this.cleanWarningMessages();
    this.setWarningMessagesFromError(error);
    console.log('onValidationWarning', error);
    if (!this.emitOnValidationWarning) {
      this.openValidationWarningConfirmModal();
    } else {
      this.$emit('validation-warning');
    }
  }

  cleanWarningMessages() {
    this.warningMessages = [];
  }

  setWarningMessagesFromError(error) {
    if (error.response.data.errors) {
      // this.errorsObject = error.response.data.errors;
      Object.keys(error.response.data.errors).forEach(field => {
        const errorField = {
          warnings: error.response.data.errors[field],
          field: field,
        };
        this.warningMessages.push(errorField);
      });
    }
  }

  openValidationWarningConfirmModal() {
    this.showValidationWarningModal = true;
  }

  async closeValidationWarningConfirmModal() {
    this.waitingValidationWarningConfirm = false;
    this.showValidationWarningModal = false;
    this.cleanWarningMessages();
  }

  async onValidationWarningConfirmed() {
    this.waitingValidationWarningConfirm = true;

    // submit form
    const formModel = this.$refs.stdForm.formModel;
    this.$set(formModel, 'no_warnings', true);
    this.$set(this.$refs.stdForm, 'formModel', formModel);
    await this.$refs.stdForm.saveEntity();
    this.waitingValidationWarningConfirm = false;

    await this.closeValidationWarningConfirmModal();
  }
}
